module.exports = __webpack_public_path__ + "img/thank-you.61723665.png";